module.exports = __webpack_public_path__ + "img/derby_320.e4332a9e.png";